import { format } from 'date-fns';
import React, { useContext } from "react";
import Context from "../../context/Context";
import { useEventContext } from "../../context/EventProvider";
import useAuthModal from "../../hooks/useAuthModal";
import { createFormattedTimeRange } from "../../utils/dates";
import { AuthLink } from "../links";
import PresentedInfo from "../presented";

export const RegisterButton = () => (
  <AuthLink
    key={"nav-hero"}
    to={"/?"}
    target="_self"
>
  <button className="registerButton">Register</button>
</AuthLink>
);

const NewHero = () => {
  const { event: {
    starts,
    ends,
    virtualStart,
    virtualEnd,
    timezone,
    siteName,
    addresses,
  }, virtual } = useEventContext();
  const locationName = addresses.length > 0 && addresses[0].location;
  // TODO: Add Strapi Event attribute for forcing TZ abbreviation.
  // When forcing the timezone abbreviation to ET, we can retrieve from Strapi
  const inPersonTimeRange = createFormattedTimeRange(starts, ends, timezone, 'ET');
  const virtualTimeRange = createFormattedTimeRange(virtualStart, virtualEnd, timezone, 'ET');
  const startDateUtc = new Date(starts);
  const endDateUtc = new Date(ends);
  const formattedStartDate = format(startDateUtc, 'MM.d.yyyy', {});
  const formattedStartTime = format(startDateUtc, 'h:mma', {});
  const formattedEndTime = format(endDateUtc, 'h:mma', {});
   const formattedEventStartToEndTime = `${formattedStartTime} - ${formattedEndTime} ET`;
  const eventTime = virtual ? virtualTimeRange : inPersonTimeRange;
  const eventLocation = virtual ? 'VIRTUAL EXPERIENCE' : locationName;
  const eventTimeAndLocation = `${eventTime} | ${eventLocation}`;

  return (
    <>
    <div className="hero" id="top">
      <div className="hero-container">
        <div className="left">
          <h2 style={{display: 'none'}}>
            <img
              src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/googledefensesummit/SNG-Wordmark-Red.png"
              alt="Scoop News Group"
              width={331}
            />{" "}
            <span>Presents</span>
          </h2>
          <div className="underwritten-container">
            <p>
              
              <img
                src="https://cdn.ems.prod.upgather.com/uploads/Google_PS_Logo_8e61f577a2.svg"
                alt="Google"
              />
            </p>
          </div>
          <h1>
            Public Sector <br />Summit
            
          </h1>
          
          <h3 className="herodate">
            16 Oct '24
          </h3>
          <RegisterButton />
          
          
        </div>
        {/*<img
          src="https://cdn.ems.prod.upgather.com/uploads/google_header_e6af6ea85e.svg"
          alt="Google Lines"
          className="right"
  />*/}
          <video className="right" autoPlay loop muted playsInline>
            <source src="https://cdn.ems.prod.upgather.com/uploads/1920x1080_Google_Animated_Graphic_ce6756c4bc.mp4" type="video/mp4"></source>
          </video>
      </div>
      
      <div className="hero-container" style={{display: 'none'}}>
        <div className="hero-desktop">
          <img
            src="https://cdn.ems.prod.upgather.com//uploads/AI_Talks_Hero_BG_e30790a220.png"
            alt="Desktop Background"
          />
          <div className="hero-content">
            <div className="hero-event-date">{formattedStartDate}</div>
            <img
              src="https://cdn.ems.prod.upgather.com//uploads/AI_Talks_Main_Hero_Logo_511462d92b.svg"
              alt={`${siteName} Desktop Hero Background`}
              className="hero-event-title"
            />
            <div className="hero-event-time">
              {eventTimeAndLocation}
            </div>
            <br />
            <RegisterButton />
            <br />
            <PresentedInfo />
          </div>
        </div>
        <div className="hero-mobile">
          <img src="https://cdn.ems.prod.upgather.com//uploads/AI_Talks_Mobile_header_895dc0b7a0.png" alt="Mobile Background" />
          <div className="hero-content">
            <img
              src="https://cdn.ems.prod.upgather.com//uploads/AI_for_AI_Talks_350805fe86.png"
              alt="AI"
              className="hero-event-title-part1"
            />
            <img
              src="https://cdn.ems.prod.upgather.com//uploads/TALKS_for_AI_Talks_dc1c09b2ef.png"
              alt={`${siteName} Mobile Hero Background`}
              className="hero-event-title-part2"
            />
            <PresentedInfo />
            <div className="hero-event-date">{formattedStartDate}</div>
            <div className="hero-event-time">
              {eventTimeAndLocation}
            </div>
            <br />
            <RegisterButton />
          </div>
        </div>
      </div>
      
    </div>
    <div className="venue-contain">
    <p className="venue-information" style={{ color: "#000" }}>
    Date: <span>{formattedStartDate}</span>
    <br className="venue-information-break" />
    <span className="venue-information-space">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span>
    Time: <span>8:00AM - 4:00PM ET</span>
    <br className="venue-information-break" />
    <span className="venue-information-space">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span>
    Location: <span>{eventLocation}</span>
  </p>
  </div>
  </>
  );
};

export default NewHero;
